// extracted by mini-css-extract-plugin
export default {"reviewsLink":"_ff667cc9"};